import axios from 'axios';
import NProgress from 'nprogress';
import { api } from '../common/constants';
import '../styles/nprogress-custom.css';

const instance = axios.create({
  baseURL: api.baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let activeRequests = 0;

instance.interceptors.request.use(
  (config) => {
    activeRequests++;
    if (activeRequests === 1) {
      NProgress.start();
    }
    if (!config.url?.includes('login') && !config.url?.includes('register')) {
      const token = localStorage.getItem('token');
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    activeRequests--;
    if (activeRequests === 0) {
      NProgress.done();
    }
    return response;
  },
  async (error) => {
    NProgress.done();
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest.isRetry && originalRequest.headers.Authorization) {
      originalRequest.isRetry = true;
      try {
        const oldRefreshToken = localStorage.getItem('refreshToken');
        const response = await axios.post(`${api.baseURL}/refresh`, { refreshToken: oldRefreshToken });
        const { token, refreshToken } = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return instance.request(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.setItem('isSessionExpired', 'true');
        window.location.href = '#/login';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
